const algoliaKey = {
  appID: 'J12DBKEGGI',
  secret: '812b1f5ca0ec382e399f07b65e0ce714'
}

const googleSheetKey = 'AIzaSyCzAX6St6SUnKBIeKITeNhpCUZlxj44ZWE'

export { algoliaKey, googleSheetKey }